import { initializeApp } from "firebase/app";
import {getAuth} from "firebase/auth";
import { getFirestore } from "firebase/firestore"; 
import "firebase/compat/auth"
const firebaseConfig = {
  apiKey: "AIzaSyDplp6kHcNQY3LueB7NTGxqQPThZxRhLMI",
  authDomain: "l9itha-16bbf.firebaseapp.com",
  projectId: "l9itha-16bbf",
  storageBucket: "l9itha-16bbf.appspot.com",
  messagingSenderId: "603508222009",
  appId: "1:603508222009:web:501b12cbee4301197a45e8",
  measurementId: "G-KNVTGW47CZ"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app); // Initialisation de Firestore

export { auth ,db};
